export default __webpack_public_path__ + "assets/images/58c52904a0d14d824e89182ce5c228c8.png";